<div>
    <h4>Select Access Group</h4>
<mat-form-field>
  <mat-label>Access Groups</mat-label>
  <select matNativeControl required name="accessGroup" [(ngModel)]="selectedAccessGroup">
    <option value="">Select Access Group</option>
    <option value="1">Access Group 1</option>
    <option value="2">Access Group 2</option>
    <option value="3">Access Group 3</option>
    <option value="4">Access Group 4</option>
  </select>
</mat-form-field>
</div>


<div>
  @if(selectedAccessGroup !== '') {
    <igx-grid #grdFacilities [data]="facilities" [width]="'100%'" [height]="'320px'" [autoGenerate]="false">
      <igx-column field="" header="" [sortable]="false" [filterable]="false" [resizable]="false" [width]="'90px'">
        <ng-template igxCell>
          <input type="checkbox" />
        </ng-template>
      </igx-column>

      <igx-column field="facilityName" header="Facility Name" [sortable]="true" [resizable]="true" [width]="'250px'"></igx-column>
      <igx-column field="facilityId" header="Facility Id" [sortable]="true" [resizable]="true" [width]="'200px'"></igx-column>
    </igx-grid>
  }
  @else{
    <p style="margin-top:20px;font-style:italic;">Select an Access Group to view Facilities</p>
  }
</div>
